'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20.679 3H3.32A.322.322 0 0 0 3 3.321V15.967H13.05a.321.321 0 0 0 .32-.321v-3.104h-.642v2.782H3.643V9.222h3.579v-.643h-3.58V3.643h9.087v.888h.643v-.888h6.986v3.825h-6.986V6.46h-.643v2.119h-3.58v.643h3.58v1.391h.643V8.111h6.986v7.18h-3.946a.322.322 0 0 0-.322.321v4.745H3.643v-2.033H3v2.355c0 .177.144.321.322.321h13.09a.321.321 0 0 0 .32-.321v-4.745h3.947a.322.322 0 0 0 .32-.322V3.321A.321.321 0 0 0 20.68 3",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }));
});
var FwSet0Livingspace200Plus = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0Livingspace200Plus = FwSet0Livingspace200Plus;